import React from 'react'
import VerifyIcon from 'assets/icons/verify-icon-2.svg'
import './style.scss'

const CustomVerifyIcon = ({ className = '' }) => {
    return <img src={VerifyIcon} alt="VerifyIcon" className={`verify-icon ${className}`} />
}

export default CustomVerifyIcon
